<template>

  <v-btn-toggle color="secondary" v-model="assessTypeData" mandatory>
    <v-btn large value="cropSprouting">
      <v-icon>
        mdi-sprout-outline
      </v-icon>
      <span v-if="!iconsOnly">
        苗情分布
      </span>
     </v-btn>
     <v-btn large value="cropGrowth">
      <v-icon>
        mdi-chart-timeline-variant
      </v-icon>
      <span v-if="!iconsOnly">
        长势监测
      </span>
     </v-btn>
     <v-btn large value="cropYield">
      <v-icon>
        mdi-grain
      </v-icon>
      <span v-if="!iconsOnly">
        产量分布
      </span>
     </v-btn>
     <v-btn large value="preAssess">
      <v-icon>
        mdi-clipboard-alert-outline
      </v-icon>
      <span v-if="!iconsOnly">
        灾害初评
      </span>
    </v-btn>
    <v-btn large value="finalAssess">
      <v-icon>
        mdi-clipboard-check-outline
      </v-icon>
      <span v-if="!iconsOnly">
        灾害终评
      </span>
    </v-btn>
  </v-btn-toggle>

</template>

<script>
export default {
  name: 'ks-assess-type-chooser',
  props: {
    assessType: { type: String, default: 'cropSprouting' },
    showAngleTool: { type: Boolean, default: false },
    iconsOnly: { type: Boolean, default: false }
  },
  data () {
    return {
      assessTypeData: this.assessType
    }
  },
  watch: {
    // listen to changed measurement type and forward to parent component
    assessTypeData (newVal, oldVal) {
      this.$emit('ks-assesstype-change', newVal, oldVal);
      console.log('assessTypeData', newVal, oldVal);
    }
  }
}
</script>

<style>
</style>
